export interface NflSeasonContext {
  lastCompleted: number;
  projectionSeason: number;
}

export function nflSeasonContext(now: Date = new Date()): NflSeasonContext {
  const year = now.getFullYear();
  const month = now.getMonth();
  const lastCompleted = month >= 2 ? year - 1 : year - 2;
  const projectionSeason = month >= 8 ? year : year;
  return { lastCompleted, projectionSeason };
}
